import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataListaPedidosReducer } from "../reducers";

import { InitialState } from "./models";

const initialState: InitialState = {
  dataListaPedidos: {
    data: [],
    requestGetParams: {
      dataInicial: "",
      dataFinal: "",
      gruposCodigos: [],
      filiaisIds: [],
      roteirosAceitos: true,
      pedidosColetados: "",
      statusEvolucao: "",
      codigoRoteiro: "",
      pagina: 1,
      itensPorPagina: 15,
    },
    pagination: {
      page: 1,
      rowsPerPage: 15,
      totalItems: 0,
      totalPages: 0,
    },
    isLoading: false,
    error: null,
  },
  filtersCSV: {
    dataInicial: "",
    dataFinal: "",
    gruposCodigos: "",
    filiaisIds: "",
    roteirosAceitos: true,
    pedidosColetados: true,
    statusEvolucao: "",
    codigoRoteiro: "",
    statusColetaRoteiros: "",
    tipoRoteiros: "",
  },
  filtersForm: {},
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Lista de pedidos",
        index: 0,
        active: true,
        name: "listaPedidos",
      },
    ],
  },
};

const listaPedidosSlice = createSlice({
  name: "listaPedidosMiniHubApp/listaPedidosMiniHub",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
      if (action.payload === 0) state.configTabs.tabs[1].active = false;
    },
    setFiltersForm: (state, action) => {
      state.filtersForm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getListaPedidos.pending, (state) => {
      state.dataListaPedidos.isLoading = true;
      state.dataListaPedidos.error = null;
    });

    builder.addCase(Actions.getListaPedidos.fulfilled, dataListaPedidosReducer);

    builder.addCase(Actions.getListaPedidos.rejected, (state, action) => {
      state.dataListaPedidos.isLoading = false;
      state.dataListaPedidos.error =
        action.error.message || "Erro ao carregar lista de pedidos";
    });
  },
});

export const { changeTab, setFiltersForm } = listaPedidosSlice.actions;

export default listaPedidosSlice.reducer;
